// extracted by mini-css-extract-plugin
module.exports = {"tabs":"e_vv","title":"e_wv","list":"e_xv","listActive":"e_yv","leftList":"e_zv","rightList":"e_Av","grid":"e_Bv"};